<script>
    export let message = '';
</script>

<div class="page-not-found">
    <div>
        <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                 class="feather feather-alert-triangle">
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                <line x1="12" y1="9" x2="12" y2="13"></line>
                <line x1="12" y1="17" x2="12.01" y2="17"></line>
            </svg>
        </div>
        <div class="message">
            { message }
        </div>
    </div>
</div>

<style>
    .page-not-found {
        display: flex;
        justify-content: center;
        align-items: center;
        height: calc(100vh - 140px);
        color: #8b8b8b;
    }

    .page-not-found .icon {
        margin: 0 auto 20px auto;
        width: 100px;
    }

    .page-not-found .message {
        max-width: 100%;
        font-size: 1.4rem;
        padding: 0 15px;
    }
</style>